// src/utils/jgRingtoneEngine.js
// Centralized audio engine for incoming ring, outgoing ring, and hangup sound.

console.log('[JG Ringtone Engine] loaded');

const INCOMING_RING_URL =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1756098711/Drinkin_The_Night_Away_-_Instrumental_MASTERED_DK_xpfhks.mp3';

const OUTGOING_RING_URL =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1756098711/Drinkin_The_Night_Away_-_Instrumental_MASTERED_DK_xpfhks.mp3';

const HANGUP_SOUND_URL =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1756187929/Instagram_end_call_sound_sffect_no-copyright_zqpcis.mp3';

export const CALL_RING_TIMEOUT_MS = 30000;

let incomingBuffer = null;
let outgoingBuffer = null;
let hangupBuffer = null;

let audioCtx = null;
let activeSource = null;
let ringType = null;
let ringGeneration = 0;

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

async function loadAudio(url) {
  const ctx = getAudioContext();
  const res = await fetch(url);
  const arr = await res.arrayBuffer();
  return ctx.decodeAudioData(arr);
}

function stopActiveSource() {
  try {
    if (activeSource) {
      activeSource.stop(0);
      activeSource.disconnect();
      activeSource = null;
    }
  } catch (err) {
    console.warn('[JG Ringtone Engine] stop error:', err);
  }
}

function playLoop(buffer, generation, type) {
  if (generation !== ringGeneration || ringType !== type) return;
  stopActiveSource();
  if (generation !== ringGeneration || ringType !== type) return;

  const ctx = getAudioContext();
  const src = ctx.createBufferSource();
  src.buffer = buffer;
  src.loop = true;

  const gainNode = ctx.createGain();
  gainNode.gain.value = 0.35;

  src.connect(gainNode).connect(ctx.destination);
  src.start(0);

  activeSource = src;
}

export async function playRingtone(type = 'incoming') {
  const normalizedType = type === 'outgoing' ? 'outgoing' : 'incoming';
  const generation = ++ringGeneration;
  ringType = normalizedType;

  try {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended' && typeof ctx.resume === 'function') {
      await ctx.resume();
    }

    if (normalizedType === 'incoming') {
      if (!incomingBuffer) incomingBuffer = await loadAudio(INCOMING_RING_URL);
      playLoop(incomingBuffer, generation, normalizedType);
    } else {
      if (!outgoingBuffer) outgoingBuffer = await loadAudio(OUTGOING_RING_URL);
      playLoop(outgoingBuffer, generation, normalizedType);
    }
  } catch (err) {
    console.warn('[JG Ringtone Engine] play error:', err);
  }
}

export function stopRingtone() {
  ringGeneration += 1;
  ringType = null;
  stopActiveSource();
}

export async function playHangupSound() {
  try {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended' && typeof ctx.resume === 'function') {
      await ctx.resume();
    }
    if (!hangupBuffer) hangupBuffer = await loadAudio(HANGUP_SOUND_URL);

    const src = ctx.createBufferSource();
    src.buffer = hangupBuffer;

    const gainNode = ctx.createGain();
    gainNode.gain.value = 0.6;

    src.connect(gainNode).connect(ctx.destination);
    src.start(0);
  } catch (err) {
    console.warn('[JG Hangup] error:', err);
  }
}

export function __resetRingtoneEngineForTests() {
  stopRingtone();
  incomingBuffer = null;
  outgoingBuffer = null;
  hangupBuffer = null;
  audioCtx = null;
  activeSource = null;
  ringType = null;
  ringGeneration = 0;
}

export function __getRingtoneDebugState() {
  return {
    hasActiveSource: !!activeSource,
    ringType,
    ringGeneration,
  };
}
